import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { severitySelect } from 'Common/styles/style';
import { updateVuln } from 'store/Manage/actions';
import SeverityIcon from 'Common/Components/SeverityIcon';
import { selectVulnDetail, selectReadOnly, selectPermissions } from 'store/Manage/selectors';
import { capitalize } from 'utils/stringUtils';
import get from 'lodash/get';
import { severities } from 'Screens/Constants';
import SeverityName from './styled';

const SeverityItem = ({ title }) => (
  <div style={ { display: 'flex', alignItems: 'center' } }>
    <SeverityIcon type={ title.charAt(0).toUpperCase() }>{title.charAt(0).toUpperCase()}</SeverityIcon>
    <SeverityName>{ capitalize(title) }</SeverityName>
  </div>
);

const SeverityPicker = () => {
  const dispatch = useDispatch();
  const vuln = useSelector(selectVulnDetail);
  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectPermissions);
  const severity = get(vuln, 'severity', '');
  const value = {
    label: severity === 'med' ? 'medium' : severity,
    value: severity
  };

  return (
    <Select
      styles={ severitySelect }
      isSearchable={ false }
      value={ value }
      disabled={ readOnly || !permissions.update?.allowed }
      onChange={ (e) => dispatch(updateVuln(vuln, 'severity', e.value)) }
      options={ severities.map((element) => ({ label: <SeverityItem title={ element.name } />, value: element.name })) }
    />
  );
};

export default SeverityPicker;
